import _ from 'underscore';

import pick from 'util/pick';
import {SampleGroup, SampleGroupUpdate, UISampleGroup} from 'workflows/WorkflowConstants';

import {RequestTaskGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTaskGraphQL';
import {UIRequestTask} from './RequestTaskConstants';

/**
 * Filter out deleted and unused tasks/samples before sending task/sample associations to the server.
 *
 * This prevents two types of errors on the server:
 * - Trying to create associations for a deleted task
 * - Trying to create associations for samples that don't exist and aren't getting created,
 *   e.g. samples filtered out by prepareSampleGroupsForServer
 */
export default function prepareTaskSampleGroupAssociationsForServer({
  requestTasks,
  sampleGroupIdsByRequestTaskId,
  sampleGroupsForServer,
}: {
  requestTasks: Array<RequestTaskGraphQL | UIRequestTask>;
  sampleGroupIdsByRequestTaskId: {[requestTaskId: string]: Array<string>};
  sampleGroupsForServer: Array<SampleGroup | UISampleGroup | SampleGroupUpdate>;
}): {[requestTaskId: string]: Array<string>} {
  const sampleGroupIdsForServer = sampleGroupsForServer.map(
    (sampleGroup) =>
      (sampleGroup as SampleGroup).id ||
      (sampleGroup as UISampleGroup).cid ||
      (sampleGroup as SampleGroupUpdate).cid
  );
  const taskIds = requestTasks.map((task) => (task as RequestTaskGraphQL).id || (task as UIRequestTask).cid);
  const sampleGroupIdsByFilteredRequestTaskId = pick(sampleGroupIdsByRequestTaskId, ...taskIds);
  return _.mapObject(sampleGroupIdsByFilteredRequestTaskId, (sampleGroupIds) =>
    sampleGroupIds.filter((id: string) => sampleGroupIdsForServer.includes(id))
  );
}
